import { useState, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Soft UI Dashboard React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiAvatar from "components/SuiAvatar";

// Soft UI Dashboard React examples
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Soft UI Dashboard React base styles
import breakpoints from "assets/theme/base/breakpoints";

import { Auth } from "aws-amplify";

// Images
import iam from "assets/images/iam-logo-circleOnly-01.png";

function Header() {
  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [username, setUser] = useState(null);
  const [accStatus, setAccStatus] = useState("");

  useEffect(() => {
    async function fetchUserInfo() {
      try {
        const value = await Auth.currentUserInfo();
        if (value.username === 'admin') {
          setUser("Admin");
          setAccStatus(value.attributes["custom:accStatus"]);
        } else {
          if (value.attributes["custom:company"] !== undefined) {
            if (value.attributes["custom:fullname"] !== undefined) {
              setUser(value.attributes["custom:fullname"]);
            } else {
              setUser(value.attributes.email);
            }
            setAccStatus(value.attributes["custom:accStatus"]);
          } else {
            setUser(value.attributes['custom:fullname']);
            setAccStatus("User");
          }
        }
      } catch (error) {
        console.error("Error fetching user info: ", error);
      }
    }

    fetchUserInfo();
  }, []);

  useEffect(() => {
    function handleTabsOrientation() {
      setTabsOrientation(window.innerWidth < breakpoints.values.sm ? "vertical" : "horizontal");
    }

    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();

    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, []);

  const getBackgroundColor = () => {
    if (accStatus === null) return "transparent";
    switch (accStatus) {
      case 'User':
        return "#285aa5";
      case 'organizer':
        return "#6aa84f";
      case 'Admin':
        return "#8E7CC3";
      default:
        return "transparent";
    }
  };

  return (
    <SuiBox position="relative">
      <DashboardNavbar absolute light />
      <SuiBox
        display="flex"
        alignItems="center"
        position="relative"
        minHeight="12.75rem"
        borderRadius="xl"
        sx={{
          backgroundColor: getBackgroundColor(),
          backgroundSize: "cover",
          backgroundPosition: "50%",
          overflow: "hidden",
        }}
      />
      <Card
        sx={{
          backdropFilter: `saturate(200%) blur(30px)`,
          backgroundColor: ({ functions: { rgba }, palette: { white } }) => rgba(white.main, 0.8),
          boxShadow: ({ boxShadows: { navbarBoxShadow } }) => navbarBoxShadow,
          position: "relative",
          mt: -8,
          mx: 3,
          py: 2,
          px: 2,
        }}
      >
        <Grid container spacing={3} alignItems="center">
          <Grid item>
            <SuiAvatar src={iam} alt="profile-image" variant="rounded" size="xl" shadow="sm" />
          </Grid>
          <Grid item>
            <SuiBox height="100%" mt={0.5} lineHeight={1}>
              <SuiTypography variant="h5" fontWeight="medium">
                {username}
              </SuiTypography>
            </SuiBox>
          </Grid>
        </Grid>
      </Card>
    </SuiBox>
  );
}

export default Header;
